// Mock data for Hiri Koiari DDA website

export const carouselImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80",
    alt: "Waterfront development"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=800&q=80",
    alt: "Community meeting"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
    alt: "Government officials"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=800&q=80",
    alt: "Infrastructure development"
  }
];

export const quickAccessCards = [
  {
    id: 1,
    icon: "Building2",
    title: "About the DDA",
    link: "/about"
  },
  {
    id: 2,
    icon: "FileText",
    title: "Our Services",
    link: "/services"
  },
  {
    id: 3,
    icon: "Calendar",
    title: "Events",
    link: "/events"
  },
  {
    id: 4,
    icon: "Phone",
    title: "Contact Us",
    link: "/contact"
  }
];

export const newsArticles = [
  {
    id: 1,
    date: "2024-02-05",
    title: "New Infrastructure Development Plan Approved",
    description: "The DDA Board has approved a comprehensive 5-year infrastructure development plan for Hiri Koiari...",
    slug: "infrastructure-plan-approved",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&q=80"
  },
  {
    id: 2,
    date: "2024-01-28",
    title: "Community Health Initiative Launch",
    description: "Partnership with local health centers to improve maternal and child health services across the district.",
    slug: "health-initiative-launch",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80"
  },
  {
    id: 3,
    date: "2025-01-15",
    title: "Education Support Program Expansion",
    description: "DDA announces expansion of school infrastructure and student support programs for 2024.",
    slug: "education-program-expansion",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80"
  },
  {
    id: 4,
    date: "2024-01-10",
    title: "Water Supply Project Completed in Rural Communities",
    description: "New water systems now providing clean water access to over 5,000 residents in remote areas of the district.",
    slug: "water-supply-project",
    image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&q=80"
  },
  {
    id: 5,
    date: "2023-12-20",
    title: "Youth Employment Program Shows Promising Results",
    description: "Economic development initiative creates new opportunities for young people through skills training and business support.",
    slug: "youth-employment-program",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80"
  },
  {
    id: 6,
    date: "2023-12-05",
    title: "Road Network Upgrade Reaches Milestone",
    description: "Major infrastructure project connecting rural communities reaches 75% completion ahead of schedule.",
    slug: "road-network-upgrade",
    image: "https://images.unsplash.com/photo-1621939514649-280e2ee25f60?w=800&q=80"
  }
];

export const servicesData = [
  {
    id: 1,
    icon: "Heart",
    title: "Health Services",
    description: "Coordinating improvements to healthcare facilities and services across Hiri Koiari District, including maternal health programs and medical infrastructure."
  },
  {
    id: 2,
    icon: "GraduationCap",
    title: "Education Development",
    description: "Supporting educational infrastructure, teacher training programs, and student assistance initiatives to improve learning outcomes."
  },
  {
    id: 3,
    icon: "Building",
    title: "Infrastructure Projects",
    description: "Managing and coordinating infrastructure development including roads, bridges, water systems, and public facilities."
  },
  {
    id: 4,
    icon: "Sprout",
    title: "Economic Development",
    description: "Facilitating economic growth through small business support, agricultural programs, and sustainable development initiatives."
  },
  {
    id: 5,
    icon: "Users",
    title: "Community Programs",
    description: "Implementing community-focused initiatives that enhance social wellbeing and community engagement."
  },
  {
    id: 6,
    icon: "Scale",
    title: "Governance Support",
    description: "Ensuring transparent and accountable management of district resources through good governance practices."
  }
];

export const projectsData = [
  {
    id: 1,
    title: "Hiri Koiari Road Network Upgrade",
    status: "In Progress",
    category: "Infrastructure",
    description: "Comprehensive upgrade of main road networks connecting communities across the district.",
    startDate: "2023-06",
    completion: 65
  },
  {
    id: 2,
    title: "Rural Health Centers Expansion",
    status: "Planning",
    category: "Health",
    description: "Construction and renovation of health centers in rural communities to improve access to healthcare.",
    startDate: "2024-03",
    completion: 25
  },
  {
    id: 3,
    title: "School Infrastructure Program",
    status: "In Progress",
    category: "Education",
    description: "Building new classrooms and facilities for primary and secondary schools across the district.",
    startDate: "2023-09",
    completion: 45
  },
  {
    id: 4,
    title: "Water Supply System Development",
    status: "Completed",
    category: "Infrastructure",
    description: "Installation of clean water systems in remote communities.",
    startDate: "2022-11",
    completion: 100
  }
];

export const announcementsData = [
  {
    id: 1,
    date: "2025-01-20",
    title: "Board Meeting Schedule - February 2025",
    content: "The DDA Board will convene for its regular monthly meeting on February 15, 2025, at 10:00 AM."
  },
  {
    id: 2,
    date: "2025-01-15",
    title: "Public Consultation - Infrastructure Plan",
    content: "Community members are invited to attend public consultation sessions on the proposed infrastructure development plan."
  },
  {
    id: 3,
    date: "2024-12-10",
    title: "Annual Report 2024 Published",
    content: "The DDA Annual Report for 2024 is now available for download on our website."
  }
];

export const eventsData = [
  {
    id: 1,
    title: "Community Consultation Forum",
    date: "2025-02-20",
    time: "9:00 AM - 3:00 PM",
    location: "Central Province Community Hall",
    description: "Open forum for community members to discuss development priorities and provide feedback on ongoing projects."
  },
  {
    id: 2,
    title: "Infrastructure Project Launch",
    date: "2025-03-05",
    time: "10:00 AM",
    location: "Hiri Koiari District Office",
    description: "Official launch ceremony for the new road network upgrade project."
  },
  {
    id: 3,
    title: "Education Stakeholders Meeting",
    date: "2025-03-15",
    time: "2:00 PM - 5:00 PM",
    location: "District Education Office",
    description: "Meeting with teachers, parents, and education officials to discuss school infrastructure improvements."
  }
];

export const objectivesData = [
  {
    id: 1,
    icon: "Target",
    title: "Service Delivery",
    description: "Improve access to essential services across health, education, and infrastructure"
  },
  {
    id: 2,
    icon: "Scale",
    title: "Good Governance",
    description: "Ensure transparent and accountable management of district resources"
  },
  {
    id: 3,
    icon: "Users",
    title: "Community Development",
    description: "Foster inclusive economic growth and social wellbeing"
  }
];


export const galleryImages = [
  {
    id: 1,
    title: "Community Health Center Opening",
    category: "Health",
    image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&q=80",
    date: "2024-02-15"
  },
  {
    id: 2,
    title: "School Infrastructure Development",
    category: "Education",
    image: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=800&q=80",
    date: "2024-01-20"
  },
  {
    id: 3,
    title: "Road Construction Project",
    category: "Infrastructure",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&q=80",
    date: "2024-01-10"
  },
  {
    id: 4,
    title: "Community Consultation Meeting",
    category: "Community",
    image: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=800&q=80",
    date: "2023-12-05"
  },
  {
    id: 5,
    title: "Water Supply System Installation",
    category: "Infrastructure",
    image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&q=80",
    date: "2023-11-28"
  },
  {
    id: 6,
    title: "Youth Skills Training Program",
    category: "Education",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80",
    date: "2023-11-15"
  },
  {
    id: 7,
    title: "Board Chairman Meeting with Community Leaders",
    category: "Governance",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
    date: "2023-10-20"
  },
  {
    id: 8,
    title: "Agricultural Extension Services",
    category: "Economic Development",
    image: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800&q=80",
    date: "2023-10-10"
  },
  {
    id: 9,
    title: "Bridge Construction Completion",
    category: "Infrastructure",
    image: "https://images.unsplash.com/photo-1587281127029-6246f81a790e?w=800&q=80",
    date: "2023-09-25"
  },
  {
    id: 10,
    title: "Women's Empowerment Workshop",
    category: "Community",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80",
    date: "2023-09-10"
  },
  {
    id: 11,
    title: "Medical Equipment Delivery",
    category: "Health",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80",
    date: "2023-08-30"
  },
  {
    id: 12,
    title: "School Graduation Ceremony",
    category: "Education",
    image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&q=80",
    date: "2023-08-15"
  }
];